<template>
  <div class="exr-item exr-item-words2">
    <el-input v-model="value.text" placeholder="文本"></el-input>
    <PinyinInput v-if="showPinyin" v-model="value.pinyin" :text="value.text" placeholder="拼音"></PinyinInput>
  </div>
</template>

<script>
import PinyinInput from "@/components/PinyinInput.vue";

export default {
  name: "PdtItemWords2",
  props: {
    value: Object,
    showPinyin: Boolean,
  },
  components: {PinyinInput}
}
</script>